import React from 'react';
import { formatNumber } from '../../helpers/formatNumber';

export const VolumeInfo = ({ car, confirmedVolumeM3, totalVolumeM3 }) => {
  const capacity = car?.capacity ? parseFloat(car?.capacity) : null;

  return (
    <div className="col">
      <div className="row">
        <label htmlFor="confirmed_volumes" className="col-lg-2 col-form-label">
          {__('volumes.confirmed_volume')}
        </label>

        <div className="row">
          <p className="font-weight-bold">
            {formatNumber(confirmedVolumeM3)}m³

            {capacity && (
              <span className='pl-5px'>
                / {formatNumber(capacity)}m³ ({formatNumber((confirmedVolumeM3 * 100) / capacity)}%)
              </span>
            )}
          </p>
        </div>
      </div>

      <div className="row">
        <label htmlFor="name" className="col-lg-2 col-form-label">
          {__('volumes.total_volume')}
        </label>

        <div className="row">
          <p className="font-weight-bold">
            {formatNumber(totalVolumeM3)}m³

            {capacity > 0 && (
              <span className='pl-5px'>
                / {formatNumber(capacity)}m³ ({formatNumber((totalVolumeM3 * 100) / capacity)}%)
              </span>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
